import { render } from "./ProspectosContent.vue?vue&type=template&id=3a10b5c2"
import script from "./ProspectosContent.vue?vue&type=script&lang=js"
export * from "./ProspectosContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__